import { environment } from './../../../environments/environment';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { RefreshToken } from '../../models/auth.model';
import { KeycloakService } from 'keycloak-angular';
import { keycloakLogin } from './keycloak-login-redirect';

const exclusionMap = {
  [environment.webPushBrokerUrl]: ['Authorization']
}

const blacklisted = (request, key) => {
  return (exclusionMap[new URL(request.url).origin] ?? []).includes(key)
}

const isSameProxyHost = (request) => {
  // TODO: entirely disable this if the build is not for review (which we have
  // to ensure is never served publicly).
  // Is there a way to compile this out entirely?
  // short-circuit if the current host doesn't end with .gapmaps.localhost
  const currentHost = window.location.host;
  if(!currentHost.endsWith('.gapmaps.localhost')) {
    return;
  }
  const parentHost = currentHost.substring(currentHost.indexOf('.') + 1);
  const requestHost = new URL(request.url).host;
  const requestParentHost = requestHost.substring(requestHost.indexOf('.') + 1);
  return requestParentHost === parentHost;
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private injector: Injector, private store: Store, private keycloakService: KeycloakService) {

    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // when operating in a local, proxied environment, include the access token when the
        // url ends with .gapmaps.localhost AND we are hosted at the same parent host
        if (!(request.url.includes('.gapmaps.com') || isSameProxyHost(request))) {
          return next.handle(request);
        }
        if(request.url.includes('refresh-token') || request.url.includes('token')) {
          return next.handle(request);
        }
        const auth = this.store.selectSnapshot((state) => state.auth);
      if (auth.token && auth.expires_at <= new Date().getTime()) {
        return from(this.store.dispatch(new RefreshToken())).pipe(
          switchMap(() => {
            const updatedAuth = this.store.selectSnapshot((state) => state.auth);
            let headers = request.headers;
            headers = headers.set('Authorization', `Bearer ${updatedAuth.token}`);
            headers = headers.set('x-access-token', updatedAuth.token);
            const req = request.clone({headers});
            return next.handle(req);
          }),
          catchError(err => {
            console.error('Token refresh failed:', err);
            void keycloakLogin(this.keycloakService);
            return next.handle(request.clone());
          })
        );
      } else if (!auth.token) {
          void keycloakLogin(this.keycloakService);
          return next.handle(request.clone());
        } else {
            let headers = request.headers;
            if(!blacklisted(request, 'Authorization')) {
              headers = headers.set('Authorization', `Bearer ${auth.token}`);
            }
            headers = headers.set('x-access-token', auth.token);
            const req = request.clone({headers});
            return next.handle(req);
        }
    }
}
